<template>
  <b-alert
    :show="dismissCountDown"
    dismissible
    fade
    :variant="variant"
    @dismissed="clear"
    @dismiss-count-down="5"
  >
    <p class="font-weight-normal">{{ msg }}</p>
  </b-alert>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Alert",
  computed: {
    ...mapGetters("alert", ["msg", "variant", "dismissCountDown"]),
  },
  methods: {
    ...mapActions("alert", ["clear"]),
  },
};
</script>
